import React, { createContext, useContext, useState, useEffect } from 'react';
import { authAPI } from '../api';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
    const [admin, setAdmin] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const token = localStorage.getItem('qb_admin_token');
        if (token) {
            authAPI
                .verify()
                .then((res) => setAdmin(res.data.data))
                .catch(() => localStorage.removeItem('qb_admin_token'))
                .finally(() => setLoading(false));
        } else {
            setLoading(false);
        }
    }, []);

    const login = async (email, password) => {
        const res = await authAPI.login({ email, password });
        const { token, ...adminData } = res.data.data;
        localStorage.setItem('qb_admin_token', token);
        setAdmin(adminData);
        return adminData;
    };

    const logout = () => {
        localStorage.removeItem('qb_admin_token');
        setAdmin(null);
    };

    return (
        <AuthContext.Provider value={{ admin, loading, login, logout }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);
